module.exports = __webpack_public_path__ + "img/xhyy.fa497b72.jpg";